import { Field, ErrorMessage } from 'formik';

const AddrLine1 = ({ loading }) => {
  return (
    <div>
      <label htmlFor='addr_line_1'>
        Address Line 1
      </label>

      <Field
        id='addr_line_1'
        aria-label='address line 1'
        name='addr_line_1'
        type='text'
        disabled={loading}
      />

      <ErrorMessage
        name='addr_line_1'
        component='div'
      />
    </div>
  );
};

export default AddrLine1;